import React from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-b from-green-100 to-gray-100 min-h-screen">
      {/* Hero Banner */}
      <div className="bg-blue-900 text-white py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 animate-fade-in">
            Refund Policy
            <span className="block text-yellow-500 mt-2">
              Fair and Transparent
            </span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6">
            At Virtueista IT, we strive to ensure satisfaction with our courses
            and services. Learn about our refund process below.
          </p>
        </div>
      </div>

      {/* Policy Content */}
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Introduction
            </h2>
            <p className="text-gray-600">
              This Refund Policy applies to all courses, workshops, and services
              provided by Virtueista IT in Biratnagar, Nepal. We aim to offer
              flexible and fair refund options to our students and clients.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Course Refunds
            </h2>
            <p className="text-gray-600">
              Refunds for our training programs are available under the
              following conditions:
            </p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>
                <strong>Within 7 Days:</strong> Full refund if you withdraw
                within 7 days of course enrollment, provided no more than 10% of
                the course content has been accessed.
              </li>
              <li>
                <strong>After 7 Days:</strong> No refunds are available after
                the 7-day period unless exceptional circumstances apply (e.g.,
                medical emergencies).
              </li>
              <li>
                <strong>Non-Attendance:</strong> Failure to attend classes does
                not qualify for a refund.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Software Service Refunds
            </h2>
            <p className="text-gray-600">
              For custom software development or other services:
            </p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>
                Refunds are evaluated on a case-by-case basis if the delivered
                service does not meet agreed specifications.
              </li>
              <li>
                No refunds are provided for completed services accepted by the
                client.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Refund Process
            </h2>
            <p className="text-gray-600">To request a refund:</p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>
                Submit a written request to{" "}
                <a
                  href="mailto:virtueistait@gmail.com"
                  className="text-blue-600 hover:underline"
                >
                  virtueistait@gmail.com
                </a>{" "}
                with your order details.
              </li>
              <li>
                Refunds are processed within 14 business days upon approval.
              </li>
              <li>Refunds will be issued to the original payment method.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Contact Us
            </h2>
            <p className="text-gray-600">
              For refund-related inquiries, contact us at{" "}
              <a
                href="mailto:virtueistait@gmail.com"
                className="text-blue-600 hover:underline"
              >
                virtueistait@gmail.com
              </a>{" "}
              or call +977-9849489441.
            </p>
          </section>
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center bg-blue-800 text-white py-12 px-4">
        <h2 className="text-3xl font-bold mb-4">Need Assistance?</h2>
        <p className="text-lg max-w-2xl mx-auto mb-6">
          Our team is here to help with any refund questions or concerns.
        </p>
        <button
          onClick={() => navigate("/contact")}
          className="bg-yellow-500 text-blue-900 py-3 px-6 rounded-md font-semibold hover:bg-yellow-600 transition-all duration-300"
        >
          Contact Us
        </button>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations */}
      <style>
        {`
          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fade-in 1s ease-out;
          }
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default RefundPolicy;
